<div id="clean-data-container">
  <div>
    <div>
      <h2>Data Processing</h2>
      <p>
        Clean and process data.
      </p>

      <p>
        Calculates average for data, creates tabs if there is more than one task in event data.
      </p>
    </div>
    <app-file-input style="flex-direction: column;" [requestFileFlags]="requestInputs" [uploadText]="requestStrings" />
  </div>

  <section id="process-project-data-component">
    <app-process-project-data-file (timesEvent)="timesEvent($event)"></app-process-project-data-file>
  </section>
  <section id="emotions-data-upload-section">
    <app-process-emotions-file (sendEmotionsDataEvent)="sendEmotionsDataEvent($event)"></app-process-emotions-file>
  </section>
  <section id="process-muse-component">
    <app-process-muse-file (sendMuseDataEvent)="sendMuseDataEvent($event)"></app-process-muse-file>
  </section>
</div>
